import Employee from "../../components/employee/Employee.component";

export default Employee;
